import { render, staticRenderFns } from "./LocalTv.vue?vue&type=template&id=645f37e7&scoped=true&"
import script from "./LocalTv.vue?vue&type=script&lang=js&"
export * from "./LocalTv.vue?vue&type=script&lang=js&"
import style0 from "./LocalTv.vue?vue&type=style&index=0&id=645f37e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f37e7",
  null
  
)

export default component.exports